
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M93.54 118.79a18.54 18.54 0 11-37.07 0M115.78 118.4H34.22a8.65 8.65 0 01-5.62-15.23 33.1 33.1 0 0011.8-25.36V64a34.6 34.6 0 1169.2 0v13.81a33.11 33.11 0 0011.75 25.33 8.64 8.64 0 01-5.57 15.26zM75.4 29V14.2"}})])
          )
        }
      }
    